module.exports = __webpack_public_path__ + "static/media/googleadds.4c92c92a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/gifs/googleadds.gif
// module id = 71
// module chunks = 0